import ScrollReveal from '@/components/base/ScrollReveal';

const items = [
  { icon: 'ri-facebook-fill', label: 'Facebook Ads' },
  { icon: 'ri-instagram-line', label: 'Instagram Ads' },
  { icon: 'ri-music-fill', label: 'TikTok Ads' },
  { icon: 'ri-window-line', label: 'Landing Pages' },
  { icon: 'ri-chat-1-line', label: 'Hooks' },
  { icon: 'ri-news-line', label: 'Headlines' },
  { icon: 'ri-percent-line', label: 'Offers' },
  { icon: 'ri-mail-line', label: 'Email Marketing' },
  { icon: 'ri-whatsapp-line', label: 'WhatsApp Messages' },
];

export default function WhatYouCreate() {
  return (
    <section className="relative bg-foreground-50 py-20 md:py-28">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-14 md:mb-20">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 border border-accent-200 text-accent-700 text-xs font-semibold tracking-wider uppercase mb-4">
              Posibilidades
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
              ¿Qué puedes crear?
            </h2>
            <p className="text-foreground-500 text-base md:text-lg max-w-2xl mx-auto">
              Con 1500+ prompts profesionales podrás generar todo tipo de contenido publicitario en minutos para:
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {items.map((item, i) => (
            <ScrollReveal key={item.label} delay={i * 0.03}>
              <div className="flex items-center gap-3 px-4 py-3.5 rounded-xl bg-white border border-foreground-100 hover:border-primary-200 hover:shadow-[0_4px_16px_rgba(0,0,0,0.04)] transition-all duration-300 group">
                <div className="w-8 h-8 rounded-lg bg-foreground-50 flex items-center justify-center group-hover:bg-primary-50 transition-colors duration-300">
                  <i className={`${item.icon} text-foreground-500 text-sm group-hover:text-primary-500 transition-colors duration-300`} />
                </div>
                <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-950 transition-colors duration-300 whitespace-nowrap">
                  {item.label}
                </span>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}